import { IPublicClientApplication } from '@azure/msal-browser'
import { BrowserRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { store } from './store'
import { AppThemeProvider } from './contexts/ThemeProvider'
import { AppThemeProviderV4 } from './contexts/ThemeProviderV4'
import { Router } from './Routes'
import './i18n/i18nextInit'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { reactPlugin } from './config/appInsights'
import { useEffect } from 'react'
import { getAuthInfo } from 'utils/MsGraphApiCall'
import { setAccessTokenLocalStorageAndCookie } from 'utils/token'

export type UsuarioPreferencias = {
  tema: 'light' | 'dark'
}

type AppProps = {
  msalInstance: IPublicClientApplication
}

export function App({ msalInstance }: AppProps) {
  useEffect(() => {
    const interval = setInterval(async () => {
      const payload = await getAuthInfo()
      setAccessTokenLocalStorageAndCookie(payload)
    }, 30 * 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <AppThemeProvider>
        <AppThemeProviderV4>
          <ReduxProvider store={store}>
            <BrowserRouter>
              <Router msalInstance={msalInstance} />
            </BrowserRouter>
          </ReduxProvider>
        </AppThemeProviderV4>
      </AppThemeProvider>
    </AppInsightsContext.Provider>
  )
}
